import featuresSlice from './features-slice'

const { setFeatures } = featuresSlice.actions

export { setFeatures }
